// src/components/Login/Login.jsx
import React, { useState, useEffect } from 'react'
import { authorize } from '../../Api'
import { submitLoginEvent } from '../../Api/hubspot'
import styles from './styles.module.css'
import DatafinitiLogo from '../HomeDR12/images/datafiniti-logo-white.svg'
import { useHistory } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useMutation } from 'react-query'
import { CircularProgress } from '@material-ui/core'
import BaseAlert from '../Snackbar/NewImplementations/BaseAlert/BaseAlert'
import ColorAlert from '../Snackbar/NewImplementations/ColorAlert/ColorAlert'
import useAlerts from '../Snackbar/NewImplementations/HooksAlerts/useAlerts'
import useServerAlert from '../Snackbar/NewImplementations/HooksAlerts/useServerAlert'

export default function Login () {
  const [userData, setUserData] = useState({ email: '', password: '' })
  const { register, handleSubmit, reset } = useForm()
  const [EmailState, setEmailState] = useState({ checked: false })
  const { checked } = EmailState
  const history = useHistory()

  // client-validation toasts
  const { alerts, closeAlert, showValidationErrors } = useAlerts()
  // server-error alert
  const { alertData, showError, onClose: closeServerAlert } = useServerAlert()

  // on mount, read "remember me" email
  useEffect(() => {
    document.title = 'Datafiniti Portal | Login'
    const saved = localStorage.getItem('dfp/email')
    if (saved) {
      // prefill form + checkbox
      setUserData({ email: saved, password: '' })
      reset({ email: saved, password: '' })
      setEmailState({ checked: true })
      localStorage.removeItem('dfp/email')
    }
  }, [reset])

  const handleInputChange = ({ target }) => {
    setUserData(d => ({ ...d, [target.name]: target.value }))
  }

  const onChangeCheckbox = e => {
    const { name, checked } = e.target
    setEmailState(s => ({ ...s, [name]: checked }))
  }

  const [mutateLogin, { isLoading }] = useMutation(() => authorize(userData), {
    onSuccess (data) {
      if (data.status >= 400) {
        showError(
          'Invalid login',
          'Please check your credentials and try again.'
        )
      } else {
        if (checked) {
          localStorage.setItem('dfp/email', userData.email)
        }
        localStorage.setItem('dfp/session', data.data.token)
        submitLoginEvent(userData.email)
        history.push('/property-data')
      }
    },
    onError () {
      showError(
        'Connection Error',
        'Failed to connect to the server. Please try again.'
      )
    }
  })

  const onSubmit = () => {
    if (!isLoading) mutateLogin()
  }

  return (
    <section className={styles.mainContainer}>
      <div className={styles.background} />
      <div className={styles.contentContainer}>
        <img
          src={DatafinitiLogo}
          alt='DatafinitiLogo'
          className={styles.logo}
        />
        <div className={styles.formContainer}>
          <form
            id='Datafiniti-Portal-Login'
            name='Datafiniti-Portal-Login'
            onSubmit={handleSubmit(onSubmit, showValidationErrors)}
            className={styles.formLogin}
          >
            <div className={styles.inputContainer}>
              <input
                name='email'
                placeholder='Email'
                className={styles.inputField}
                autoFocus
                autoComplete='off'
                {...register('email', {
                  required: 'Email is required',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i,
                    message: 'Invalid email format'
                  },
                  onChange: handleInputChange
                })}
                value={userData.email}
              />
              <input
                name='password'
                type='password'
                placeholder='Password'
                className={styles.inputField}
                autoComplete='off'
                {...register('password', {
                  required: 'Password is required',
                  onChange: handleInputChange
                })}
                value={userData.password}
              />
            </div>

            <div className={styles.checkboxContainer}>
              <div style={{ display: 'flex' }}>
                <input
                  type='checkbox'
                  id='rememberMe'
                  className={styles.checkbox}
                  name='checked'
                  checked={checked}
                  onChange={onChangeCheckbox}
                />
                <label htmlFor='rememberMe' className={styles.checkboxLabel}>
                  Remember me
                </label>
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <button
                type='submit'
                className={styles.loginButton}
                disabled={isLoading}
                data-retry='true'
              >
                {isLoading ? (
                  <CircularProgress
                    size={24}
                    className={styles.circularProgress}
                  />
                ) : (
                  'Login'
                )}
              </button>
              <button
                type='button'
                onClick={() => history.push('/sign-up')}
                className={styles.signupButton}
              >
                Sign up
              </button>
            </div>

            <span
              onClick={() => history.push('/forgot-password')}
              className={styles.forgotPassword}
            >
              Forgot Password
            </span>
          </form>
        </div>
      </div>

      {/* stacked client-validation toasts */}
      {alerts.map((a, i) => (
        <ColorAlert
          key={a.id}
          open={a.open}
          type={a.type}
          label={a.message}
          onClose={() => closeAlert(a.id)}
          style={{ bottom: 20 + i * 80 }}
        />
      ))}

      {/* single server-error modal */}
      <BaseAlert
        open={!!alertData}
        title={alertData?.title}
        body={alertData?.body}
        actions={alertData?.actions}
        onClose={closeServerAlert}
      />
    </section>
  )
}
